module.exports = __webpack_public_path__ + "static/img/stamp.4a84de6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stamp.png
// module id = 184
// module chunks = 2